export default __webpack_public_path__ + "static/media/survey.d91e7469.svg";